import React from "react";
import PropTypes from "prop-types";

import strategyBenchmarkChartHtml from "../../../../../lib/StrategyBenchmarkChart/strategybenchmarkchart.html";

const StrategyBenchmarkChartFrame = ({ frameRef, height, onFrameLoad }) => (
  <div className="strategy-benchmark-chart__frame" style={{ height }}>
    <iframe
      ref={frameRef}
      src={strategyBenchmarkChartHtml}
      title="Strategy benchmark chart"
      className="strategy-benchmark-chart__iframe"
      onLoad={onFrameLoad}
    />
  </div>
);

StrategyBenchmarkChartFrame.propTypes = {
  frameRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]).isRequired,
  height: PropTypes.number.isRequired,
  onFrameLoad: PropTypes.func.isRequired
};

export default StrategyBenchmarkChartFrame;
